<template>
  <div class="wrap">
    <div class="head">
      <img :src="`${ossUrl}comeOrder/time.png`" alt="">
      <span>报名时间：{{form.ruleDTO && form.ruleDTO.startDate}} ~ {{form.ruleDTO && form.ruleDTO.endDate}}</span>
    </div>
    <div class="reward" :style="{ height: form.ruleDTO && form.ruleDTO.rewardType !== 3 ? '526px' : '410px'}">
      <div class="logo_img"><img :src="`${ossUrl}comeOrder/come-reward.png`" alt=""></div>
      <div class="table">
        <div><span>奖励档次</span><span>{{form.ruleDTO && form.ruleDTO.thresholdIndexType && form.ruleDTO && form.ruleDTO.thresholdIndexType === 1? '交易总流水' : '交易总笔数' }}</span><span>返现规则</span><span v-if="form.ruleDTO && form.ruleDTO.rewardType !== 3">预计最高奖励金额</span></div>
        <div v-for="(item, index ) in form.rewardLevelDTOList" :key="index">
          <span>{{item.level || '-'}}</span>
          <span>{{item.waterOrOrderCount || '-'}}{{form.ruleDTO && form.ruleDTO.thresholdIndexType === 1? '元' : '笔' }}</span>
          <!--返现规则四种情况-->
          <!--全量流水-->
          <template v-if="form.ruleDTO.rewardType === 1 && form.ruleDTO.thresholdIndexType === 1">
            <span>总流水 x <span style="color: #FF2420">{{item.calcRule || '-'}}%</span></span>
          </template>
          <!--增量流水-->
          <template v-if="form.ruleDTO.rewardType === 2 && form.ruleDTO.thresholdIndexType === 1">
            <span>超出{{item.waterOrOrderCount}}元的部分 x <span style="color: #FF2420">{{item.calcRule || '-'}}%</span></span>
          </template>
          <!--全量订单-->
          <template v-if="form.ruleDTO.rewardType === 1 && form.ruleDTO.thresholdIndexType === 2">
            <span>每笔返现<span style="color: #FF2420">{{item.calcRule || '-'}}</span>元</span>
          </template>
          <!--增量订单-->
          <template v-if="form.ruleDTO.rewardType === 2 && form.ruleDTO.thresholdIndexType === 2">
            <span>超出{{item.waterOrOrderCount}}笔的部分每笔返现<span style="color: #FF2420">{{item.calcRule || '-'}}</span>元</span>
          </template>
          <!-- 固定模式 -->
          <template v-if="form.ruleDTO.rewardType === 3">
            <span>超过{{item.waterOrOrderCount}}{{form.ruleDTO.thresholdIndexType === 2?'笔':'元'}}，奖励<span style="color: #FF2420">{{item.calcRule || '-'}}</span>元</span>
          </template>
          <span v-if="form.ruleDTO.rewardType !== 3">{{item.expectedMaximumReward || '-'}}{{item.expectedMaximumReward === '无上限' ? '' : '元' }}</span>
        </div>
      </div>
      <div class="tooltip" v-if=" form.ruleDTO && form.ruleDTO.rewardType !== 3">
        <div class="to_left">
          <div>示例</div>
          <div>当油站交易总{{form.ruleDTO && form.ruleDTO.thresholdIndexType === 1? '流水' : '笔数' }}达到 {{form.exampleCalcFormula && form.exampleCalcFormula[0] || '-'}} {{form.ruleDTO && form.ruleDTO.thresholdIndexType === 1? '元' : '笔' }}时</div>
        </div>
        <div class="to_right">
          <!--全量公式-->
          <template v-if="form.ruleDTO && form.ruleDTO.rewardType === 1">
            <div class="to_card"><span>交易总流水</span><span>{{form.exampleCalcFormula && form.exampleCalcFormula[1] || '-'}}{{form.ruleDTO && form.ruleDTO.thresholdIndexType === 1? '元' : '笔' }}</span></div>
            <div class="fu">x</div>
            <div class="to_card"><span>{{form.ruleDTO && form.ruleDTO.thresholdIndexType === 1? '返现比例' : '每笔返现' }}</span><span>{{form.exampleCalcFormula && form.exampleCalcFormula[2] || '-'}}</span></div>
            <div class="fu">=</div>
            <div class="dou"><span>{{form.exampleCalcFormula && form.exampleCalcFormula[3] || '-'}}元</span></div>
          </template>
          <!--增量公式-->
          <template v-else>
            <!--增量公式--多个计算-->
            <template v-if="form.exampleCalcFormula && form.exampleCalcFormula.length === 4">
              <div class="to_card"><span><img :src="`${ossUrl}comeOrder/gold.png`" alt=""></span><span>{{form.exampleCalcFormula && form.exampleCalcFormula[1] || '-'}}</span></div>
              <div class="fu">+</div>
              <div class="to_card"><span><img :src="`${ossUrl}comeOrder/gold.png`" alt=""></span><span>{{form.exampleCalcFormula && form.exampleCalcFormula[2] || '-'}}</span></div>
              <div class="fu">=</div>
              <div class="dou"><span>{{form.exampleCalcFormula && form.exampleCalcFormula[3] || '-'}}元</span></div>
            </template>
            <!--增量公式--单个计算-->
            <template v-else>
              <div class="to_card"><span><img :src="`${ossUrl}comeOrder/gold.png`" alt=""></span><span>{{form.exampleCalcFormula && form.exampleCalcFormula[1] || '-'}}</span></div>
              <div class="fu">=</div>
              <div class="dou"><span>{{form.exampleCalcFormula && form.exampleCalcFormula[2] || '-'}}元</span></div>
            </template>
          </template>
        </div>
      </div>
    </div>
    <div class="word">
      <div class="introduce">
        <span>活动说明</span>
        <span>{{form.explainDTO && form.explainDTO.totalExplain || '-'}}</span>
        <span>交易订单需要满足以下条件:</span>
        <span>1.订单渠道: {{form.explainDTO && form.explainDTO.orderChannelExplain || '-'}}</span>
        <span>2.订单用户: {{form.explainDTO && form.explainDTO.userExplain || '-'}}</span>
        <span>3.订单油号: {{form.explainDTO && form.explainDTO.oilExplain || '-'}}</span>
        <span>4.在活动期间或活动结束后7天之内，退款中和已退款的订单不计入至流水中</span>
      </div>
      <div class="wo_reward">
        <span>奖励说明</span>
        <span>活动结束7天后次日0点，团油平台计算油站对应的奖励金；</span>
        <span>活动结束7天后次日10点，将奖励金打入到账户中，报名时，请谨慎填写收款账户信息；</span>
      </div>
    </div>
    <div class="btn">
      <el-button class="btn_item" size="medium" @click="$router.go(-1)">返回</el-button>
      <el-button class="btn_item" type="primary" size="medium" v-if="form.checkVO && form.checkVO.status === 1" @click="next">下一步</el-button>
      <el-button class="btn_item" type="primary" size="medium" v-if="form.checkVO && form.checkVO.status === 2" @click="handleFin">活动已结束</el-button>
      <el-button class="btn_item" type="primary" size="medium" v-if="form.checkVO && form.checkVO.status === 3" @click="handleCheck">查看已报名</el-button>
    </div>
  </div>
</template>
<script>
// rewardType 1-全量 2-增量  thresholdIndexType 1-流水 2-订单
import { previewOrder, checkGasSale } from '@/api/marketPromotion'
import {ossUrl} from '@/utils/config'
export default {
  data () {
    return {
      ossUrl,
      form: {}
    }
  },
  methods: {
    async previewOrderApi (ruleId) {
      try {
        const { code, result } = await previewOrder({ ruleId })
        if (code !== 200) return
        const { checkVO, ruleDTO, explainDTO, rewardLevelDTOList, exampleCalcFormula } = result
        this.form = { checkVO, ruleDTO, explainDTO, rewardLevelDTOList, exampleCalcFormula }
      } catch (error) {
        console.log(error)
      }
    },
    async next () {
      const resGasSale = await checkGasSale()
      if (!resGasSale.result) {
        return this.$message.info('未查询到油站MD,请联系您的客户经理')
      }
      this.$router.push({ path: '/promotion/runAchieve', query: { ruleId: this.form.checkVO.ruleId } })
    },
    handleFin () {
      this.$message.info('该活动目前已结束，请下期及时报名参加')
    },
    handleCheck () {
      this.$router.push({ path: '/promotion/activeList' })
    }
  },
  mounted () {
    const { ruleId } = this.$route.query
    this.previewOrderApi(ruleId)
  }
}
</script>
<style scoped lang="less">
.wrap{
  width: 100%;
  // height: 100%;
  margin-top: 20px;
  background: #B20A3A;
  padding: 0 30px;
  position: relative;
  .head{
    width: 100%;
    height: 415px;
    background: url('https://web.nlktj.com/ty/merchant/comeOrder/backShow.png') no-repeat 85%;
    background-size: 85% 100%;
    position: relative;
    >img{
      display: block;
      width: 520px;
      height: 260px;
    }
    >span{
      position: absolute;
      top: 27%;
      left: 88px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
    }
  }
  .reward{
    width: 100%;
    height: 526px;
    background: #FFF1F5;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    .logo_img{
      width: 100%;
      height: 92px;
      background: linear-gradient(180deg, #FEC1D1 0%, rgba(254, 193, 209, 0) 100%);
      border-radius: 16px 16px 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
      >img{
        display: block;
        width: 408px;
        height: 88px;
      }
    }
    .table{
      width: 98%;
      border-radius: 8px;
      margin-top: 20px;
      border:1px solid #FDB6CA;
      background: #fff;
      >div{
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        border-bottom: 1px solid #FDB6CA;
        >span{
          width: 24%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      >div:nth-child(1){
        background: #FFDBE6;
        border-radius: 8px 8px 0 0;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #B20A3A;
      }
      div:nth-last-child(1){
        border-bottom: none;
      }
    }
    .tooltip{
      width: 98%;
      height: 86px;
      margin-top: 20px;
      border:1px solid #FDB6CA;
      background: #fff;
      border-radius: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: absolute;
      bottom: 20px;
      .to_left{
        width: 20%;
        height: 86px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        >div:nth-child(1){
          font-size: 20px;
          font-family: MF-FangHeiNoncommercial-Regular, MF-FangHeiNoncommercial;
          font-weight: 800;
          color: #D45B7E;
        }
        >div:nth-child(2){
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
      .to_right{
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .to_card{
          min-width: 120px;
          padding: 10px;
          height: 70px;
          background: #FFF1F5;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          >span:nth-child(1){
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #D45B7E;
          }
          >span:nth-child(2){
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #B20A3A;
          }
        }
        .fu{
          color: #E93C6D;
          margin: 0 20px;
        }
        .dou{
          width: 128px;
          height: 70px;
          background: url('https://web.nlktj.com/ty/merchant/comeOrder/dou.png') no-repeat;
          background-size: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          >span{
            display: inline-block;
            width: 120px;
            text-align: center;
            margin-bottom: 20px;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #C92F10;
          }
        }
      }
    }
  }
  .word{
    width: 100%;
    padding: 20px 20px;
    .introduce{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      >span:nth-child(1){
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        padding: 15px 10px 5px 10px;
      }
      >span:nth-child(2), >span:nth-child(3){
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        padding: 10px 10px;
      }
      >span:nth-child(4), >span:nth-child(5),  >span:nth-child(6), >span:nth-child(7){
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        padding: 5px 10px;
      }
    }
    .wo_reward{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-bottom: 100px;
      >span{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        padding: 10px 10px;
      }
      >span:nth-child(1){
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        padding: 20px 10px 10px 10px;
        margin-top: 10px;
      }
    }
  }
  .btn{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 60px;
    background: #fff;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .btn_item{
      width: 120px;
      height: 40px;
    }
  }
}
</style>